import React, {Fragment} from "react";
import {ModalBody, ModalFooter, Row} from "reactstrap";
import ZeusButton from "../../../components/Button";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import InputCreator from "../../../components/Forms/components/InputCreator";
import ToggleCreator from "../../../components/Forms/components/ToggleCreator";
import ChoiceSets from "./choiceSets";
import {useFormData} from "./useFormData";

const CustomFieldsForm = (props) => {
  const {data, onCancel} = props;
  const {
    fieldTypesOptions,
    formData,
    handleChange,
    handleSubmit,
    objectTypesOptions,
    relatedObjectTypesOptions,
  } = useFormData(data, onCancel);
  const {
    choice_set = "",
    default: defaultValue = "",
    description = "",
    id,
    is_required = false,
    is_unique = false,
    label = "",
    name = "",
    object_types = [],
    related_object_type = "",
    type = "",
  } = formData;

  const showChoiceSetSelection = type === "select" || type === "multiselect";
  const showRelatedObjectTypeSelection = type === "object" || type === "multiobject";

  return (
    <Fragment>
      <ModalBody>
        <Row>
          <SelectCreator
            classNamePrefix={"object-types"}
            description="The type(s) of object that have this custom field"
            id={"object-types"}
            isMulti
            isRequired
            inSingleRow
            label="Object Types"
            large
            name="object_types"
            onChange={handleChange}
            options={objectTypesOptions}
            value={object_types}
          />
          <InputCreator
            data-cy="name"
            description="Internal field name"
            inSingleRow
            isRequired
            label="Name"
            large
            name="name"
            onChange={handleChange}
            value={name}
          />
          <InputCreator
            data-cy="label"
            description="Name of the field as displayed to users"
            inSingleRow
            isRequired
            label="Label"
            large
            name="label"
            onChange={handleChange}
            value={label}
          />
          <InputCreator
            description="This will be displayed as help text for the form field"
            inSingleRow
            label="Description"
            large
            name="description"
            onChange={handleChange}
            value={description}
          />
          <SelectCreator
            classNamePrefix={"field-type"}
            description="The type of data stored in this field. For object/multi-object fields, select the related object type below."
            id={"field-type"}
            inSingleRow
            isDisabled={Boolean(id)}
            isRequired
            label="Field Type"
            large
            name="type"
            onChange={handleChange}
            options={fieldTypesOptions}
            value={type}
          />
          {(type === "text" || type === "longtext") && (
            <InputCreator
              data-cy="default"
              inSingleRow
              label="Default value"
              large
              name="default"
              onChange={handleChange}
              type={type === "text" ? "text" : "textarea"}
              value={defaultValue}
            />
          )}
          {type === "number" && (
            <InputCreator
              inSingleRow
              label="Default value"
              large
              name="default"
              onChange={handleChange}
              type="number"
              value={defaultValue}
            />
          )}
          {type === "boolean" && (
            <ToggleCreator
              inSingleRow
              label="Default value"
              large={true}
              name="default"
              checked={defaultValue}
              onChange={() =>
                handleChange({target: {name: "default", value: !defaultValue}})
              }
            />
          )}
          {showChoiceSetSelection && (
            <ChoiceSets
              isDisabled={Boolean(id)}
              onChange={handleChange}
              value={choice_set}
            />
          )}
          {showRelatedObjectTypeSelection && (
            <SelectCreator
              classNamePrefix={"related-object-type"}
              description="Type of the related object (for object/multi-object fields only)"
              id={"related-object-type"}
              isDisabled={Boolean(id)}
              isRequired
              inSingleRow
              label="Related Object Type"
              large
              name="related_object_type"
              onChange={handleChange}
              options={relatedObjectTypesOptions}
              value={related_object_type}
            />
          )}
          <ToggleCreator
            inSingleRow
            label="Required"
            large={true}
            name="is_required"
            checked={is_required}
            onChange={() =>
              handleChange({target: {name: "is_required", value: !is_required}})
            }
          />
          <ToggleCreator
            inSingleRow
            label="Must Be Unique"
            large={true}
            name="is_unique"
            checked={is_unique}
            onChange={() =>
              handleChange({target: {name: "is_unique", value: !is_unique}})
            }
          />
        </Row>
      </ModalBody>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
          SAVE
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </Fragment>
  );
};

export default CustomFieldsForm;
